import { useQuery } from '@apollo/client';

import { TINDER_LIKED_USERS } from '../graphql/query/tinderLikedUsersQuery.graphql';

export const useTinderLikedUsersQuery = (eventId: string) => {
  return useQuery(TINDER_LIKED_USERS, {
    variables: { eventId },
    fetchPolicy: 'cache-and-network',
  });
};
